import type { DsIAuthService } from "./DsIAuthService";
import { useCookies } from "@vueuse/integrations/useCookies";

export class DsCookieAuthService implements DsIAuthService {
  /**
   * A list of cookies used to manage the authentication.
   *
   * @protected
   */
  protected cookies = useCookies(["token"]);

  /**
   * Save the token in the local storage.
   *
   * @param token
   */
  setToken(token: string): void {
    this.cookies.set("token", token, {
      path: "/",
      domain: import.meta.env.VITE_APP_COOKIE_DOMAIN,
    });
  }

  /**
   * Get the curren token stored in the local storage.
   *
   * @returns string
   */
  getToken(): string {
    return this.cookies.get("token") ?? "";
  }

  /**
   * @returns boolean
   */
  isAuthenticated(): boolean {
    return this.getToken() !== "";
  }

  /**
   * Clear all cookies for the authentication.
   */
  logout(): void {
    this.cookies.remove("token", {
      path: "/",
      domain: import.meta.env.VITE_APP_COOKIE_DOMAIN,
    });
  }
}
